export default "__VITE_ASSET__DGw1JMEM__"